import { AnimatePresence, motion } from "framer-motion";
import { PROFILE, EXPERIENCE, SKILLS, EDUCATION } from "../data/content";

const BODY = {
  about: (
    <p className="font-mono text-base leading-relaxed text-[#8A9AAB]">{PROFILE.summary}</p>
  ),
  experience: (
    <div className="space-y-5">
      {EXPERIENCE.map((e) => (
        <div key={e.id}>
          <p className="font-mono text-base text-[#01FFFF]">{e.role} — {e.shortName}</p>
          <p className="font-mono text-xs text-[#8A9AAB]">{e.company} · {e.period}</p>
          <ul className="mt-2 space-y-1.5">
            {e.bullets.map((b, i) => (
              <li key={i} className="font-mono text-sm leading-relaxed text-[#8A9AAB]">
                — {b}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  ),
  projects: (
    <p className="font-mono text-base leading-relaxed text-[#8A9AAB]">
      Walk up to any glowing hologram pedestal in this plaza and click it to
      inspect the project.
    </p>
  ),
  skills: (
    <div className="flex flex-wrap gap-2">
      {SKILLS.categories.flatMap((c) => c.items).map((s) => (
        <span key={s} className="border border-[#8A9AAB]/25 px-3 py-1.5 font-mono text-sm text-[#E0E6ED]">
          {s}
        </span>
      ))}
    </div>
  ),
  education: (
    <div className="space-y-3">
      {EDUCATION.map((ed) => (
        <p key={ed.id} className="font-mono text-base text-[#8A9AAB]">
          <span className="text-[#E0E6ED]">{ed.institution}</span> — {ed.degree}
        </p>
      ))}
    </div>
  ),
  contact: (
    <div className="space-y-3 font-mono text-base text-[#8A9AAB]">
      <a href={`mailto:${PROFILE.email}`} className="block hover:text-[#01FFFF]">{PROFILE.email}</a>
      <a href={PROFILE.linkedinUrl} target="_blank" rel="noopener noreferrer" className="block hover:text-[#01FFFF]">LinkedIn</a>
      <a href={PROFILE.cvUrl} download className="mt-2 inline-block border border-[#01FFFF] px-4 py-2.5 text-sm uppercase tracking-widest text-[#01FFFF]">
        Download CV
      </a>
    </div>
  ),
};

const LABELS = {
  about: "01 — ABOUT",
  experience: "02 — EXPERIENCE",
  projects: "03 — PROJECTS",
  skills: "04 — SKILLS",
  education: "05 — EDUCATION",
  contact: "06 — SYSTEM ACCESS",
};

export default function SectionPanel({ activePOI }) {
  return (
    <div className="pointer-events-none fixed inset-0 z-40 flex items-center justify-center px-6">
      <AnimatePresence>
        {activePOI && (
          <motion.div
            key={activePOI}
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.94 }}
            transition={{ duration: 0.3 }}
            data-testid="game-section-panel"
            className="pointer-events-auto w-full max-w-lg border border-[#01FFFF]/30 bg-[#0A0A12]/92 backdrop-blur-xl p-7 md:p-9 shadow-[0_0_60px_rgba(1,255,255,0.08)]"
          >
            <p className="font-mono text-sm uppercase tracking-[0.3em] text-[#01FFFF] mb-4">
              {LABELS[activePOI]}
            </p>
            {BODY[activePOI]}
            <p className="mt-6 font-mono text-[11px] uppercase tracking-widest text-[#8A9AAB]/60">
              Walk away from the portal to close
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
